export default __webpack_public_path__ + "static/media/profile.10ff1dd2.jpg";